import moment from 'moment';
import hasFullName from './utilities/hasFullName';
import hasCapitalizedFields from './utilities/hasCapitalizedFields';
import hasReportView from './utilities/hasReportView';
import hasScheduledAction from './utilities/hasScheduledAction';
import hasNotes from './utilities/hasNotes';
import hasAttachments from './utilities/hasAttachments';

const report = (reportJson) => {

  let date = reportJson.attributes.responses.find(response => response && response.datetime);
  date = date && date.datetime;

  if (reportJson.attributes.schedule) {
    date = reportJson.attributes.schedule.observationDate;
  }

  if (!date) {
    date = reportJson.attributes.insertedAt
  }

  const properties = {
    ...reportJson.attributes,
    date: moment(date).format('MMM D, YYYY'),
    rawDate: moment(date).toDate(),
    guid: reportJson.guid,
    type: reportJson.type,
  };

  return Object.assign(
    properties,
    hasCapitalizedFields(reportJson.attributes),
    hasFullName(reportJson.attributes),
    hasReportView(reportJson.attributes),
    hasScheduledAction(reportJson),
    hasNotes(reportJson.attributes.notes),
    hasAttachments(reportJson.attributes.attachments),
  );
};

export default report;
